<template>
  <div>
    <Header :notHome="true" ref="headerLine"></Header>
    <pageNav :breadcrumbsList="breadcrumbsList" :showBanner="false" :isDetail="true"></pageNav>
    <div class="detail-area" ref="detailArea">
      <div class="detail-bg">
        <div class="bg-img">
            <img src='../../assets/image/bg33.png' class="d-sm-none d-xl-block" />
            <img src='../../assets/image/bg34.png' class="d-sm-block d-xl-none" />
        </div>
      </div>
      <div class="detail-box">
        <div class="detail-title">
          {{ info.title }}
        </div>
        <div class="detail-date">
          {{ (info.publishDate||'').replace(/-/g,'/') }}
        </div>
        <div class="detail-content ql-editor">
          <div class="html-div" v-html="info.content"></div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { getNewsDetail } from "@/api/news"
export default {
  data() {
    return {
      breadcrumbsList: [{
        title: '首页'
      }, {
        title: '新闻动态'
      }, {
        title: '中心资讯'
      }],
      id: null,
      type: null,
      scroll: null,
      info: {
        publishDate: ''
      },
      offsetTop: 0
    }
  },
  mounted() {
    this.countViewCount()
    this.id = this.$route.query.contentId
    this.type = this.$route.query.type
    this.scroll = this.$route.query.scroll
    this.scroll = this.$route.query.scroll
    let result = this.getNavListByType(this.type, this.scroll, true)
    this.breadcrumbsList = result.list
    this.getDetail()
    this.$nextTick(() => {
      // this.offsetTop=this.$refs.detailArea.offsetTop-2
      if (this.type != 'news') {
        this.$refs.headerLine.changeCurrent(this.type)
      }
    })
  },
  methods: {
    getDetail() {
      getNewsDetail({ contentId: this.id }).then(res => {
        if (res.code == 200) {
          this.info = res.data
          if(this.type!='honor'){
          this.breadcrumbsList[this.breadcrumbsList.length - 2].url = `/newsList?categoryOne=${this.info.categoryOne}&categoryTwo=${this.info.categoryTwo}&type=${this.type}&scroll=${this.scroll}`
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
.detail-area {
  min-height: 100vh;
  // padding: 0 20px;
  .detail-bg {
    width: 100%;
    z-index: -1;
    position: fixed;
    min-height: 2453px;
    top: 160px;
  }
  .detail-box {
    max-width: 1000px;
    padding: 0 10px;
    min-height: 100vh;
    margin: 0 auto;
    padding-bottom: 60px;
    .detail-title {
      padding-top: 60px;
      font-family: "SourceHanSansCN-Regular";
      font-weight: bold;
      font-size: 48px;
      color: #333333;
      line-height: 72px;
    }
    .detail-date {
      font-family: "SourceHanSansCN-Regular";
      font-weight: 400;
      font-size: 20px;
      color: #999999;
      line-height: 30px;
      margin-top: 20px;
      margin-bottom: 60px;
    }
    .detail-content {
      width: 100%;
      .test-img {
        width: 100%;
        text-align: center;
        margin: 40px 0;
        img {
          max-width: 435px;
        }
      }
    }
  }
}
@media (min-width: 576px) and (max-width: 1200px) {
  .detail-bg {
    height: calc(100vh - 524px) !important;
  }
  .detail-box {
    padding: 0 24px;
  }
}
</style>